import React, {useState} from 'react';

import {useAdditionalSeedData, ThemeIcon} from 'pageflow-scrolled/frontend';
import {Dialog, Transition} from '@headlessui/react';
import {useUserData} from './useUserData';

import {UserIcon, UserOnlineIcon} from './icons';

import styles from './SubscriptionButtons.module.css';
import transitionStyles from './transitions.module.css';

export function SubscriptionButtons() {
  const {
    loginUrl,
    logoutUrl,
    profileUrl
  } = useAdditionalSeedData('handelsblatt');

  const user = useUserData();

  let [dialogOpen, setDialogOpen] = useState(false);

  if (user) {
    return (
      <div>
        <button onClick={() => setDialogOpen(true)}
                className={styles.openDialog}
                title={`Angemeldet als ${user.displayName}`}>
          <UserOnlineIcon />
          <div className={styles.shortUserName}>
            {user.displayName}
          </div>
        </button>

        <Transition
          appear={true}
          show={dialogOpen}
          as={React.Fragment}>
          <Dialog onClose={() => setDialogOpen(false)}
                  className={styles.dialog}>
            <Transition.Child
              enter={transitionStyles.fade}
              enterFrom={transitionStyles.fadeOut}
              enterTo={transitionStyles.fadeIn}
              leave={transitionStyles.fade}
              leaveFrom={transitionStyles.fadeIn}
              leaveTo={transitionStyles.fadeOut}>
              <div className={styles.backdrop} aria-hidden="true" />
            </Transition.Child>
            <div className={styles.panelContainer}>
              <Transition.Child
                enter={transitionStyles.fade}
                enterFrom={transitionStyles.fadeOut}
                enterTo={transitionStyles.fadeIn}
                leave={transitionStyles.fade}
                leaveFrom={transitionStyles.fadeIn}
                leaveTo={transitionStyles.fadeOut}>
                <Dialog.Panel className={styles.panel}>
                  <button className={styles.close}
                          title="Schließen"
                          onClick={() => setDialogOpen(false)}>
                    <ThemeIcon name="close" width={15} height={15}/>
                  </button>

                  <div className={styles.dialogHeader}>
                    <div className={styles.avatar}>
                      {user.initials}
                    </div>
                    <div className={styles.userName}>
                      {user.displayName}
                    </div>
                  </div>

                  <ul className={styles.subscriptionLinks}>
                    <li>
                      <a href={profileUrl}>
                        Konto verwalten
                      </a>
                    </li>
                    <li>
                      <a href={logoutUrl}>
                        Abmelden
                      </a>
                    </li>
                  </ul>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </div>
    );
  }
  else {
    return (
      <>
        <a href={loginUrl}
           className={styles.loginWide}>
          <UserIcon />
          Anmelden
        </a>
        <a href={loginUrl}
           className={styles.loginSmall}
           title="Anmelden">
          <UserIcon />
        </a>
        <a href="https://abo.handelsblatt.com"
           className={styles.subscribe}>
          Abo
        </a>
      </>
    );
  }
}
